import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'tripleChamili';
const args = {};

export class TripleChamili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
